import { PengajuanPelatihanRepositoryInterface } from '../../../data/contracts/PengajuanPelatihan';
import { PengajuanPelatihanDataMapper } from '../../../data/mappers/PengajuanPelatihan';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { PengajuanPelatihan } from '../../../entities/PengajuanPelatihan';
import { GetLocalStorage } from '../../misc/UseLocalStorage';

export class PengajuanPelatihanApiRepository
  implements PengajuanPelatihanRepositoryInterface
{
  private apiService: ApiService;
  private mapper: PengajuanPelatihanDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: PengajuanPelatihanDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllPengajuanPelatihan(
    page: number,
    rows: number,
    keyword: string,
    tahun: string,
    sub_menu_jenis_pelatihan_id: string,
    event_id: string | null
  ): Promise<PengajuanPelatihan[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      GetLocalStorage({ name: 'tokenAuth' }) !== undefined
        ? this.endpoints.pengajuan_pelatihan()
        : 'public/' + this.endpoints.pengajuan_pelatihan(),
      {
        page: page,
        rows: rows,
        keyword: keyword,
        tahun: tahun,
        sub_menu_jenis_pelatihan_id: sub_menu_jenis_pelatihan_id,
        ...(event_id !== null && { event_id }),
      },
      null,
      headers
    );
    return this.mapper.convertListPengajuanPelatihanDataFromApi(dataResponse);
  }

  public async getDetailPengajuanPelatihan(
    id: number
  ): Promise<PengajuanPelatihan> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      GetLocalStorage({ name: 'tokenAuth' }) !== undefined
        ? this.endpoints.pengajuan_pelatihan() + '/' + id
        : 'public/' + this.endpoints.pengajuan_pelatihan() + '/' + id,
      {},
      null,
      headers
    );
    return this.mapper.convertDetailPengajuanPelatihanDataFromApi(dataResponse);
  }

  public async storePengajuanPelatihan(
    sub_menu_jenis_pelatihan_id: number,
    jenis_pelatihan_id: number,
    judul_pelatihan: string,
    jenis_penilaian_id: string,
    waktu_buka_pendaftaran: string,
    waktu_tutup_pendaftaran: string,
    waktu_mulai: string,
    waktu_selesai: string,
    penyelenggara: string,
    informasi_umum: string,
    persyaratan: string,
    angkatan: string,
    kompetensi_teknis: string,
    is_ppkb: boolean,
    materi_inti: string,
    is_for_guru_madrasah: boolean,
    path_thumbnail: File,
    link_evaluasi: string,
    logo_penyelenggara: File
  ): Promise<any> {
    const headers = new Map<string, string>();

    headers.set('Content-Type', 'multipart/form-data');
    let formData = new FormData();
    if (path_thumbnail instanceof File) {
      formData.append('path_thumbnail', path_thumbnail);
    }
    formData.append(
      'sub_menu_jenis_pelatihan_id',
      sub_menu_jenis_pelatihan_id.toString()
    );
    formData.append('jenis_pelatihan_id', jenis_pelatihan_id.toString());
    formData.append('judul_pelatihan', judul_pelatihan);
    formData.append('waktu_mulai', waktu_mulai);
    formData.append('waktu_selesai', waktu_selesai);
    formData.append('waktu_buka_pendaftaran', waktu_buka_pendaftaran);
    formData.append('waktu_tutup_pendaftaran', waktu_tutup_pendaftaran);
    formData.append('penyelenggara', penyelenggara);
    formData.append('informasi_umum', informasi_umum);
    formData.append('kompetensi_teknis', kompetensi_teknis);
    formData.append('persyaratan', persyaratan);
    formData.append('angkatan', angkatan);
    formData.append('is_ppkb', is_ppkb ? '1' : '0');
    formData.append('materi_inti', materi_inti);
    formData.append('jenis_penilaian_id', jenis_penilaian_id);
    formData.append('is_for_guru_madrasah', is_for_guru_madrasah ? '1' : '0');

    if (link_evaluasi !== '') {
      formData.append('link_evaluasi', link_evaluasi);
    }

    if (logo_penyelenggara instanceof File) {
      formData.append('logo_penyelenggara', logo_penyelenggara);
    }

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.pengajuan_pelatihan(),
      null,
      formData,
      headers
    );
    return dataResponse;
  }

  public async updatePengajuanPelatihan(
    id: number,
    sub_menu_jenis_pelatihan_id: number,
    jenis_pelatihan_id: number,
    judul_pelatihan: string,
    jenis_penilaian_id: string,
    waktu_buka_pendaftaran: string,
    waktu_tutup_pendaftaran: string,
    waktu_mulai: string,
    waktu_selesai: string,
    penyelenggara: string,
    informasi_umum: string,
    persyaratan: string,
    angkatan: string,
    kompetensi_teknis: string,
    is_ppkb: boolean,
    materi_inti: string,
    is_for_guru_madrasah: boolean,
    path_thumbnail: File,
    status_pengajuan: string,
    link_evaluasi: string,
    logo_penyelenggara: File
  ): Promise<any> {
    const headers = new Map<string, string>();

    headers.set('Content-Type', 'multipart/form-data');
    let formData = new FormData();
    if (typeof path_thumbnail !== 'string') {
      formData.append('path_thumbnail', path_thumbnail);
    }
    formData.append(
      'sub_menu_jenis_pelatihan_id',
      sub_menu_jenis_pelatihan_id.toString()
    );
    formData.append('jenis_pelatihan_id', jenis_pelatihan_id.toString());
    formData.append('judul_pelatihan', judul_pelatihan);
    formData.append('waktu_mulai', waktu_mulai);
    formData.append('waktu_selesai', waktu_selesai);
    formData.append('waktu_buka_pendaftaran', waktu_buka_pendaftaran);
    formData.append('waktu_tutup_pendaftaran', waktu_tutup_pendaftaran);
    formData.append('penyelenggara', penyelenggara);
    formData.append('informasi_umum', informasi_umum);
    formData.append('kompetensi_teknis', kompetensi_teknis);
    formData.append('persyaratan', persyaratan);
    formData.append('angkatan', angkatan);
    formData.append('status_pengajuan', status_pengajuan.toString());
    formData.append('is_ppkb', is_ppkb ? '1' : '0');
    formData.append('materi_inti', materi_inti);
    formData.append('is_for_guru_madrasah', is_for_guru_madrasah ? '1' : '0');
    formData.append('jenis_penilaian_id', jenis_penilaian_id);

    if (link_evaluasi !== '') {
      formData.append('link_evaluasi', link_evaluasi);
    }

    if (logo_penyelenggara instanceof File) {
      formData.append('logo_penyelenggara', logo_penyelenggara);
    }

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.pengajuan_pelatihan() + '/' + id,
      null,
      formData,
      headers
    );
    return dataResponse;
  }

  public async updateStatusPengajuanPelatihan(
    id: number,
    status_pengajuan: string,
    alasan: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    headers.set('Content-Type', 'multipart/form-data');
    let formData = new FormData();
    formData.append('status_pengajuan', status_pengajuan.toString());

    if (alasan !== '') {
      formData.append('alasan', alasan.toString());
    }

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.pengajuan_pelatihan() + '/' + id,
      null,
      formData,
      headers
    );
    return dataResponse;
  }

  public async deletePengajuanPelatihan(id: number): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'delete',
      this.endpoints.pengajuan_pelatihan() + '/' + id,
      {},
      null,
      headers
    );
    return dataResponse;
  }
}
